import FieldEditorProvider from './FieldEditor.provider';

export default FieldEditorProvider;
